import { useCallback, useState } from "react"
import { centsClient } from "../../../api/cents/clients/cents-client"

interface SubscriptionRecurrenceChangeHook {
  deactivate: () => Promise<void>
  clearError: () => void
  error: 'deactivation_error' | undefined
  state: 'idle' | 'loading' | 'success'
}
export function useSubscriptionDeactivation(charityId: string, contractId: string): SubscriptionRecurrenceChangeHook {
  const [error, setError] = useState<'deactivation_error'>()
  const [state, setState] = useState<'idle' | 'loading' | 'success'>('idle')

  const clearError = useCallback(() => {
    setError(undefined)
  }, [])

  const deactivate = useCallback(async () => {
    setState('loading')
    try {
      await centsClient.contracts.updateSubscription(charityId, contractId, { delete: true })
    } catch {
      setError("deactivation_error")
      return
    } finally {
      setState('idle')
    }
    setState('success')
  }, [charityId, contractId])

  return { deactivate, clearError, error, state }
}